import PIXI from '../GameEngine/pixi.js';
import Button from './ButtonSolid.js'
import ButtonSmallInfo from './ButtonSmallInfo.js'
export default class RoundSummaryHorizontal extends PIXI.Container {
    constructor(...arg) {
        super(...arg);

        this.round = 1;
        this.interactive = true;
        this.on('pointerdown', this.close_onClick.bind(this));

        //colors: 0x479ACE, 0xC03500, 0x4CAF50

        // //background
        // var popupBackground = new PIXI.Graphics();
        // popupBackground.beginFill(0x000000);
        // //popupBackground.drawRect(-500,-500, 1000, 1000);
        // popupBackground.alpha = 0.1;
        // this.addChild(popupBackground);

        this.container = new PIXI.Container();
        this.addChild(this.container);

        var styleTitle = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 32 * 2,
            fill: '#FFFFFF',
            wordWrap: true,
            wordWrapWidth: 800,
            align: 'center'
        });
        var styleLarge = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 32 * 2,
            fill: '#FFFFFF'
        });
        var styleNormal = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 24 * 2,
            fill: '#FFFFFF',
            align: 'center'
        });
        var styleLabel = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 14 * 2,
            fill: '#FFFFFF',
            align: 'center'
        });
        let styleMedium = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 16 * 2,
            fill: '#FFFFFF'
        });

        let styleSmall = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 12 * 2,
            fill: '#FFFFFF'
        });


        const height = 180;
        const width = 380;
        const rowHeight = 40;
        const colWidth = 50;
        const paddingX = 10;

        const gridX = 40;

        const paddingY = 10;
        const row0Y = 7;
        const row0Height = 30;
        const row1Y = 18;
        const row1Height = 40;
        const row2Y = 60;
        const row2Height = 40;
        const textTopPadding = 7;




        //background
        var graphics = new PIXI.Graphics();
        graphics.beginFill(0x333333);
        graphics.lineStyle(0, 0xFFFFFF, 1);
        // graphics.drawRect(0, 0, 500, 500);
        graphics.drawRoundedRect(0, 0, width, height, 10);
        graphics.alpha = 0.8;
        this.container.addChild(graphics);




        // //textTitle
        // this.textTitle = new PIXI.Text('Round', styleTitle);
        // this.textTitle.x = colWidth * 12;
        // this.textTitle.y = row0Y;
        // this.textTitle.anchor.set(0.5, 0);
        // this.textTitle.scale.set(0.5);
        // this.container.addChild(this.textTitle);




        //point background 2
        this.playerPointBackground1 = new PIXI.Graphics();
        this.playerPointBackground1.beginFill(0xFFFFFF); // or 0x479ACE or 0xC03500
        this.playerPointBackground1.lineStyle(0, 0xFFFFFF, 1);
        this.playerPointBackground1.drawRoundedRect(gridX + colWidth * 1 - (colWidth / 2), row1Y, colWidth * 5, row1Height, 10);
        this.container.addChild(this.playerPointBackground1);


        //player's score column indicator 
        this.playerScoreHighlight1 = new PIXI.Graphics();
        this.playerScoreHighlight1.lineStyle(2, 0xFFFFFF, 1);
        this.playerScoreHighlight1.drawRoundedRect(gridX + colWidth * 1 - (colWidth / 2), row1Y, colWidth * 5, row1Height, 10);
        this.container.addChild(this.playerScoreHighlight1);


        //point background
        this.playerPointBackground2 = new PIXI.Graphics();
        this.playerPointBackground2.beginFill(0xFFFFFF); // or 0x479ACE or 0xC03500
        this.playerPointBackground2.lineStyle(0, 0xFFFFFF, 1);
        this.playerPointBackground2.drawRoundedRect(gridX + colWidth * 1 - (colWidth / 2), row2Y, colWidth * 5, row2Height, 10);
        this.container.addChild(this.playerPointBackground2);


        //player's score column indicator 
        this.playerScoreHighlight2 = new PIXI.Graphics();
        this.playerScoreHighlight2.lineStyle(2, 0xFFFF00, 1);
        this.playerScoreHighlight2.drawRoundedRect(gridX + colWidth * 1 - (colWidth / 2), row2Y, colWidth * 5, row2Height, 10);
        this.playerScoreHighlight2.visible = false;
        this.container.addChild(this.playerScoreHighlight2);



        //square behind the avatars
        this.playerAvatarBackground1 = new PIXI.Graphics();
        this.playerAvatarBackground1.beginFill(0xFFFFFF); // or 0x479ACE or 0xC03500
        this.playerAvatarBackground1.lineStyle(0, 0xFFFFFF, 1);
        this.playerAvatarBackground1.drawRoundedRect(paddingX, row1Y, 40, 40, 0);
        this.container.addChild(this.playerAvatarBackground1);

        //square behind the avatars
        this.playerAvatarBackground2 = new PIXI.Graphics();
        this.playerAvatarBackground2.beginFill(0xFFFFFF); // or 0x479ACE or 0xC03500
        this.playerAvatarBackground2.lineStyle(0, 0xFFFFFF, 1);
        this.playerAvatarBackground2.drawRoundedRect(paddingX, row2Y, 40, 40, 0);
        this.container.addChild(this.playerAvatarBackground2);

        //avatars
        this.Avatar1 = new PIXI.Sprite();
        this.Avatar1.x = paddingX;
        this.Avatar1.y = row1Y;
        this.Avatar1.width = 40;
        this.Avatar1.height = 40;
        this.container.addChild(this.Avatar1);

        this.Avatar2 = new PIXI.Sprite();
        this.Avatar2.x = paddingX;
        this.Avatar2.y = row2Y;
        this.Avatar2.width = 40;
        this.Avatar2.height = 40;
        this.container.addChild(this.Avatar2);


        //player indicator 1
        this.textPlayerIndicator1 = new PIXI.Text('*', styleNormal);
        this.textPlayerIndicator1.x = gridX + 20 + colWidth * 0;
        this.textPlayerIndicator1.y = row1Y + textTopPadding;
        this.textPlayerIndicator1.anchor.set(0.5, 0);
        this.textPlayerIndicator1.scale.set(0.5);
        this.textPlayerIndicator1.visible = false;
        this.container.addChild(this.textPlayerIndicator1);

        //player indicator 2
        this.textPlayerIndicator2 = new PIXI.Text('*', styleNormal);
        this.textPlayerIndicator2.x = gridX + 20 + colWidth * 0;
        this.textPlayerIndicator2.y = row2Y + textTopPadding;
        this.textPlayerIndicator2.anchor.set(0.5, 0);
        this.textPlayerIndicator2.scale.set(0.5);
        this.textPlayerIndicator2.visible = false;
        this.container.addChild(this.textPlayerIndicator2);



        //textPlayer1Name
        this.textPlayer1Name = new PIXI.Text('You', styleSmall);
        this.textPlayer1Name.x = gridX + colWidth * 0;
        this.textPlayer1Name.y = row1Y + (row2Height / 2);
        this.textPlayer1Name.anchor.set(0, 0.5);
        this.textPlayer1Name.scale.set(0.5);
        this.textPlayer1Name.visible = false;
        this.container.addChild(this.textPlayer1Name);

        //textPlayer2Name
        this.textPlayer2Name = new PIXI.Text('Computer', styleSmall);
        this.textPlayer2Name.x = gridX + colWidth * 0;
        this.textPlayer2Name.y = row2Y + (row1Height / 2);
        this.textPlayer2Name.anchor.set(0, 0.5);
        this.textPlayer2Name.scale.set(0.5);
        this.textPlayer2Name.visible = false;
        this.container.addChild(this.textPlayer2Name);



        //textStarterLabel
        this.textStarterLabel = new PIXI.Text('✂️', styleLabel);
        this.textStarterLabel.x = gridX + colWidth * 1;
        this.textStarterLabel.y = row0Y;
        this.textStarterLabel.anchor.set(0.5, 0);
        this.textStarterLabel.scale.set(0.5);
        this.container.addChild(this.textStarterLabel);

        //textStarterLabel
        this.textStarterValue1 = new PIXI.Text('5', styleNormal);
        this.textStarterValue1.x = gridX + colWidth * 1;
        this.textStarterValue1.y = row1Y + textTopPadding;
        this.textStarterValue1.anchor.set(0.5, 0);
        this.textStarterValue1.scale.set(0.5);
        this.container.addChild(this.textStarterValue1);

        //textStarterValue2
        this.textStarterValue2 = new PIXI.Text('16', styleNormal);
        this.textStarterValue2.x = gridX + colWidth * 1;
        this.textStarterValue2.y = row2Y + textTopPadding;
        this.textStarterValue2.anchor.set(0.5, 0);
        this.textStarterValue2.scale.set(0.5);
        this.container.addChild(this.textStarterValue2);

        //textPlayLabel
        this.textPlayLabel = new PIXI.Text('▶️', styleLabel);
        this.textPlayLabel.x = gridX + colWidth * 2;
        this.textPlayLabel.y = row0Y;
        this.textPlayLabel.anchor.set(0.5, 0);
        this.textPlayLabel.scale.set(0.5);
        this.container.addChild(this.textPlayLabel);

        //textStarterLabel
        this.textPlayValue1 = new PIXI.Text('5', styleNormal);
        this.textPlayValue1.x = gridX + colWidth * 2;
        this.textPlayValue1.y = row1Y + textTopPadding;
        this.textPlayValue1.anchor.set(0.5, 0);
        this.textPlayValue1.scale.set(0.5);
        this.container.addChild(this.textPlayValue1);

        //textStarterValue2
        this.textPlayValue2 = new PIXI.Text('16', styleNormal);
        this.textPlayValue2.x = gridX + colWidth * 2;
        this.textPlayValue2.y = row2Y + textTopPadding;
        this.textPlayValue2.anchor.set(0.5, 0);
        this.textPlayValue2.scale.set(0.5);
        this.container.addChild(this.textPlayValue2);

        //textPlayLabel
        this.textHandLabel = new PIXI.Text('✋', styleLabel);
        this.textHandLabel.x = gridX + colWidth * 3;
        this.textHandLabel.y = row0Y;
        this.textHandLabel.anchor.set(0.5, 0);
        this.textHandLabel.scale.set(0.5);
        this.container.addChild(this.textHandLabel);

        //textPlayLabel
        this.textHandValue1 = new PIXI.Text('23', styleNormal);
        this.textHandValue1.x = gridX + colWidth * 3;
        this.textHandValue1.y = row1Y + textTopPadding;
        this.textHandValue1.anchor.set(0.5, 0);
        this.textHandValue1.scale.set(0.5);
        this.container.addChild(this.textHandValue1);

        //textPlayValue2
        this.textHandValue2 = new PIXI.Text('4', styleNormal);
        this.textHandValue2.x = gridX + colWidth * 3;
        this.textHandValue2.y = row2Y + textTopPadding;
        this.textHandValue2.anchor.set(0.5, 0);
        this.textHandValue2.scale.set(0.5);
        this.container.addChild(this.textHandValue2);

        //textPlayLabel
        this.textCribLabel = new PIXI.Text('🐱', styleLabel);
        this.textCribLabel.x = gridX + colWidth * 4;
        this.textCribLabel.y = row0Y;
        this.textCribLabel.anchor.set(0.5, 0);
        this.textCribLabel.scale.set(0.5);
        this.container.addChild(this.textCribLabel);

        //textPlayLabel
        this.textCribValue1 = new PIXI.Text('23', styleNormal);
        this.textCribValue1.x = gridX + colWidth * 4;
        this.textCribValue1.y = row1Y + textTopPadding;
        this.textCribValue1.anchor.set(0.5, 0);
        this.textCribValue1.scale.set(0.5);
        this.container.addChild(this.textCribValue1);

        //textPlayValue2
        this.textCribValue2 = new PIXI.Text('4', styleNormal);
        this.textCribValue2.x = gridX + colWidth * 4;
        this.textCribValue2.y = row2Y + textTopPadding;
        this.textCribValue2.anchor.set(0.5, 0);
        this.textCribValue2.scale.set(0.5);
        this.container.addChild(this.textCribValue2);


        //line background
        var line = new PIXI.Graphics();
        line.lineStyle(2, 0xFFFFFF, 2);
        line.moveTo(gridX + (colWidth * 4) + (colWidth / 2), row1Y);
        line.lineTo(gridX + (colWidth * 4) + (colWidth / 2), row1Y + row1Height);
        this.container.addChild(line);

        //line background
        var line2 = new PIXI.Graphics();
        line2.lineStyle(2, 0xFFFFFF, 2);
        line2.moveTo(gridX + (colWidth * 4) + (colWidth / 2), row2Y);
        line2.lineTo(gridX + (colWidth * 4) + (colWidth / 2), row2Y + row2Height);
        this.container.addChild(line2);

        //textStarterLabel
        this.textTotalLable = new PIXI.Text('', styleLabel);
        this.textTotalLable.x = gridX + colWidth * 5;
        this.textTotalLable.y = row0Y;
        this.textTotalLable.anchor.set(0.5, 0);
        this.textTotalLable.scale.set(0.5);
        this.container.addChild(this.textTotalLable);

        //textStarterLabel
        this.textTotalValue1 = new PIXI.Text('5', styleNormal);
        this.textTotalValue1.x = gridX + colWidth * 5;
        this.textTotalValue1.y = row1Y + textTopPadding;
        this.textTotalValue1.anchor.set(0.5, 0);
        this.textTotalValue1.scale.set(0.5);
        this.container.addChild(this.textTotalValue1);

        //textStarterValue2
        this.textTotalValue2 = new PIXI.Text('16', styleNormal);
        this.textTotalValue2.x = gridX + colWidth * 5;
        this.textTotalValue2.y = row2Y + textTopPadding;
        this.textTotalValue2.anchor.set(0.5, 0);
        this.textTotalValue2.scale.set(0.5);
        this.container.addChild(this.textTotalValue2);


        //textPlayer2Name
        this.textAnalyzeLabel = new PIXI.Text('', styleSmall);
        this.textAnalyzeLabel.x = width - 40 - paddingX;
        this.textAnalyzeLabel.y = row0Y;
        this.textAnalyzeLabel.scale.set(0.5);
        this.container.addChild(this.textAnalyzeLabel);

        //Analyze hand button
        this.btnAnalyze1 = new ButtonSmallInfo("100", 0x444444, 40, styleMedium);
        this.btnAnalyze1.x = width - 40 - paddingX;
        this.btnAnalyze1.y = row1Y;
        this.btnAnalyze1.interactive = true;
        this.btnAnalyze1.on('pointerdown', this.btnAnalyze1_onClick.bind(this));
        this.container.addChild(this.btnAnalyze1);

        //Analyze hand  button
        this.btnAnalyze2 = new ButtonSmallInfo("100", 0x444444, 40, styleMedium);
        this.btnAnalyze2.x = width - 40 - paddingX;
        this.btnAnalyze2.y = row2Y;
        this.btnAnalyze2.interactive = true;
        this.btnAnalyze2.on('pointerdown', this.btnAnalyze2_onClick.bind(this));
        this.container.addChild(this.btnAnalyze2);

        //Explain  button
        this.btnExplain = new Button("Explain", 0xC03500, 175);
        this.btnExplain.x = 10;
        this.btnExplain.y = height - 60 - 10;
        this.btnExplain.interactive = true;
        this.btnExplain.on('pointerdown', this.btnExplain_onClick.bind(this));
        this.container.addChild(this.btnExplain);


        //Next Round  button
        this.btnNext = new Button("Play", 0x479ACE, 175);
        this.btnNext.x = 10 + 175 + 10;
        this.btnNext.y = height - 60 - 10;
        this.btnNext.interactive = true;
        this.btnNext.on('pointerdown', this.btnNext_onClick.bind(this));
        this.container.addChild(this.btnNext);


        //next indicator ready
        this.btnHighlightReady = new PIXI.Graphics();
        this.btnHighlightReady.lineStyle(2, 0xFFFF00, 3);
        this.btnHighlightReady.drawRoundedRect(10 + 175 + 10, height - 60 - 10, 175, 60, 10);
        this.container.addChild(this.btnHighlightReady);








    }
    update() {
        let isDirty = false;
        let hideContinue = this.hideContinue;
        let readyPlayer1 = this.readyPlayer1;
        let readyPlayer2 = this.readyPlayer2;


        if (this.btnHighlightReady.visible !== readyPlayer1 || readyPlayer2) isDirty = true;

        this.btnHighlightReady.visible = readyPlayer1 || readyPlayer2;

        //if hideContinue hide btnHighlightReady
        if (hideContinue) this.btnHighlightReady.visible = false;

        this.isDirty = isDirty;
    }
    //should the game data model be passed in here or a view model created by the gamescene?
    //since it is js, either is possible as long as it has the same properties it needs. 
    //The view model is more reusable and testable.
    //the data model is more direct and less code to write.  The view model is more work to write but easier to test.
    populate(data,tablePosition, hideContinue) {
        if (!data) return;

        // data = {
        //     round: 1,
        //     tablePosition: "player1",
        //     players: [
        //         {
        //             player: "player1",
        //             color: 0xFF0000,
        //             Name: "Moo",
        //                 avatarUrl: "assets/Avatars/Moo.png",
        //             Starter: 0,
        //             Play: 0,
        //             Hand: 0,
        //             Crib: 0,
        //             Total: 0,
        //             Analyze: 0
        //         }, {
        //             player: "player2",
        //             color: 0xFF0000,
        //             Name: "Batman",
        //             avatarUrl: "assets/Avatars/Batman.png",
        //             Starter: 0,
        //             Play: 0,
        //             Hand: 0,
        //             Crib: 0,
        //             Total: 0,
        //             Analyze: 0
        //         }
        //     ]
        // };

        //used for analyze round and hand button
        this.round = data.round;
        const players = data.players ?? [];



        //order player and put tablePosition last
        players.sort((a, b) => {
            if (a.tablePosition === tablePosition) return 1;
            if (b.tablePosition === tablePosition) return -1;
            return 0;
        });

        //assign color if not passed in
        players.forEach(player => {
            if (!player.color) {
                player.color = player.tablePosition === "player1" ? 0x479ACE  : 0xC03500;
            }
        });

        //set colors
        this.playerPointBackground1.tint = players[0]?.color || 0x479ACE;
        this.playerPointBackground2.tint = players[1]?.color || 0xC03500;
        this.playerAvatarBackground1.tint = players[0]?.color || 0x479ACE;
        this.playerAvatarBackground2.tint = players[1]?.color || 0xC03500;

        this.analyze1Player = players[0]?.tablePosition;
        this.analyze2Player = players[1]?.tablePosition;

        let avatarUrl1 = players[0]?.avatar;
        let avatarUrl2 = players[1]?.avatar;

        if (!players[0]) players[0] = {};
        if (!players[1]) players[1] = {};

        this.textPlayer1Name.text = players[0].name || "You";
        this.textStarterValue1.text = (players[0].starter || 0);
        this.textPlayValue1.text = (players[0].play || 0);
        this.textHandValue1.text = (players[0].hand || 0);
        this.textCribValue1.text = (players[0].crib || 0);
        this.textTotalValue1.text = (players[0].total || 0);

        this.textPlayer2Name.text = players[1].name || "Computer";
        this.textStarterValue2.text = (players[1].starter || 0);
        this.textPlayValue2.text = (players[1].play || 0);
        this.textHandValue2.text = (players[1].hand || 0);
        this.textCribValue2.text = (players[1].crib || 0);
        this.textTotalValue2.text = (players[1].total || 0);


        this.btnAnalyze1.text = players[0].analyzerScore || 0;
        this.btnAnalyze2.text = players[1].analyzerScore || 0;

        //hide score column indicators for now
        this.playerScoreHighlight1.visible = false;
        this.playerScoreHighlight2.visible = false;

        //show score column indicator
        this.playerScoreHighlight1.visible = tablePosition == players[0].tablePosition;
        this.playerScoreHighlight2.visible = tablePosition == players[1].tablePosition;



        // //show player indicator
        // this.textPlayerIndicator1.visible = tablePosition == "player1";
        // this.textPlayerIndicator2.visible = tablePosition == "player2";


        //if hideContinue hide btnNext
        this.btnNext.alpha = hideContinue ? 0.5 : 1;
        //if hideContinue hide btnHighlightReady
        if (hideContinue) this.btnHighlightReady.visible = false;

        //avatars
        //only copy if different url as texture
        if (avatarUrl1 && this.Avatar1.url !== avatarUrl1) {
            let texture = this.getTexture(avatarUrl1);
            if (texture) {
                this.Avatar1.texture = this.getTexture(avatarUrl1);
                this.Avatar1.url = avatarUrl1; //cache the url
            }
        }
        if (avatarUrl2 && this.Avatar2.url !== avatarUrl2) {
            let texture = this.getTexture(avatarUrl2);
            if (texture) {
                this.Avatar2.texture = this.getTexture(avatarUrl2);
                this.Avatar2.url = avatarUrl2; //cache the url
            }
        }


        this.isDirty = true;
    }
    getTexture(url) {
        if (url.indexOf("http") !== -1) {
            return PIXI.Texture.from(url);
        } else if (url.indexOf("assets/") !== -1) {
            return PIXI.Texture.from(url);
        } else {
            let resource = PIXI.Loader.shared.resources[url];
            return resource && resource.texture ? resource.texture : null;
        }
    }
    btnExplain_onClick(event) {
        if (this.onExplain) {
            this.onExplain(this.round);
        }
        event.stopPropagation();
    }
    btnNext_onClick(event) {
        if (this.onNext) {
            this.onNext();
        }
        event.stopPropagation();
        //this.visible = false;
        //this.parent.isDirty = true;
        // this.parent.isDirty = true;
        // this.parent.removeChild(this);

    }
    btnAnalyze1_onClick(event) {
        if (this.onAnalyze) {
            const player = this.analyze1Player;
            this.onAnalyze(this.round, player);
        }
        event.stopPropagation();
    }
    btnAnalyze2_onClick(event) {
        if (this.onAnalyze) {
            const player = this.analyze2Player;
            this.onAnalyze(this.round, player);
        }
        event.stopPropagation();
    }
    close_onClick(event) {
        if (this.onClose) {
            this.onClose();
        }
        event.stopPropagation();
        //this.visible = false;
        //this.parent.isDirty = true;
        //  this.parent.isDirty = true;
        //   this.parent.removeChild(this);
    }
}